const DAYS_NUMBER = 90
const pastDaysOptions: Options = []


// days before
for(let i = -DAYS_NUMBER; i <= -2; i++) pastDaysOptions.push({value: i, label: Math.abs(i) + ' days before'})
pastDaysOptions.push({value: -1, label: '1 day before'})


// Future Days
const futureDaysOptions: Options = []
// // today
// futureDaysOptions.push({value: 0, label: 'Trigger day'})
// // days after
// futureDaysOptions.push({value: 1, label: '+1 day'})
// for (let i = 2; i <= DAYS_NUMBER; i++) futureDaysOptions.push({value: i, label: i + ' days after'})
// today
futureDaysOptions.push({value: 0, label: 'Current Date'})
// days after
futureDaysOptions.push({value: 1, label: 'Current Date + 1 day'})
for (let i = 2; i <= DAYS_NUMBER; i++) futureDaysOptions.push({value: i, label: `Current Date + ${i} days`})




export const options        = pastDaysOptions.concat(futureDaysOptions)
export const pastAndFutureOptions  = pastDaysOptions.concat(futureDaysOptions)
export const pastOptions    = futureDaysOptions
export const futureOptions  = futureDaysOptions